module.exports = __webpack_public_path__ + "static/media/do1.02f0f61c.png";